import {round} from './round';

const roundTo4DecimalPlaces = (num: number): number => round(4)(num);

export {roundTo4DecimalPlaces};
